export const queryValidator = (query) => {
  let queryString = query.replace(/\s+/g, '');
  let errorString = '';
  let leftBracket = queryString.split('(').length -1;
  let rightBracket = queryString.split(')').length -1;
  let notCount = queryString.split('(!').length -1;


  if (notCount > 1) {
    errorString = errorString + '\nnot(! ) 조건의 갯수가 올바르지 않습니다.';
  }

  if (leftBracket-rightBracket != 0) {
    errorString = errorString + ('\n( , ) 의 갯수가 일치하지 않습니다.')
  }


  if (errorString == ''){
    return true;
  }
  else {
    alert(errorString)
    return false;
  }


  // if (leftBracket-rightBracket == 0) {
    
  // }

  // if ()
}